export default "__VITE_ASSET__FM4ZUAWVNkExmaesQ0KEow__"